import { AutoTableRowContext } from "./auto-table-row-provider.contants";
import { IProps } from "./auto-table-row-provider.types";

const AutoTableRowProvider = <T,>({ row, rowLink, children }: IProps<T>) => {
    return <AutoTableRowContext.Provider value={{ row, rowLink }}>{children}</AutoTableRowContext.Provider>;
};

export { AutoTableRowProvider };
